// src/application/EmissionService.js
import { EmissionRepository } from '../infrastructure/EmissionRepository';
import { VehicleEmission } from '../domain/Emission/VehicleEmission';

export class EmissionService {
    constructor() {
        this.emissionRepository = new EmissionRepository();
    }

    async getVehicleEmissionTrail(vehicleId, month) {
        try {
            const response = await this.emissionRepository.fetchVehicleEmissionTrail(vehicleId, month);
            const emissionPoints = response.data; // 提取 data 屬性

            if (response.code === 0) {
                if (!Array.isArray(emissionPoints)) {
                    throw new TypeError('API response data is not an array');
                }
                return emissionPoints.map(point => new VehicleEmission(
                    point.vehicleId,
                    point.startLatitude,
                    point.startLongitude,
                    point.emissionAmount,
                    point.startTime
                ));
            }
            return [];
        } catch (error) {
            console.error('Error fetching vehicle emission trail:', error);
            throw new Error('獲取車輛碳排放軌跡時發生錯誤');
        }
    }

    async getEmissionStats() {
        try {
            return await this.emissionRepository.fetchEmissionStats();
        } catch (error) {
            console.error('Error fetching emission stats:', error);
            throw new Error('獲取碳排放統計數據時發生錯誤');
        }
    }

    async getEmissionRankings() {
        try {
            return await this.emissionRepository.fetchEmissionRankings();
        } catch (error) {
            console.error('Error fetching emission rankings:', error);
            throw new Error('獲取碳排放排名時發生錯誤');
        }
    }
}